export default {"src":"/_next/static/media/black-knight.5c01ad34.svg","height":67,"width":260,"blurWidth":0,"blurHeight":0};